import React from "react";
import NavLink from "../common/NavLink";
import { connect } from "react-redux";

class TeacherMenuItems extends React.Component {
  render() {
    return <div className="vertical-menu">
        <NavLink to="/dashboard">
          <i className="fa fa-th-large" aria-hidden="true" />
          <span>داشبورد</span>
        </NavLink>
        <NavLink to="/dashboard/products">
          <i className="fa fa-book" aria-hidden="true" />
          <span>محصولات</span>
        </NavLink>
        <NavLink to="/dashboard/online-tests">
          <i className="fa fa-pencil" aria-hidden="true" />
          <span>طراحی سوال</span>
        </NavLink>
        {/*<NavLink to="/dashboard/credit">
          <i className="fa fa-credit-card" aria-hidden="true" />
          <span>اعتبار</span>
        </NavLink>*/}
        {/*
          <NavLink to="/dashboard/profile">
          <i className="fa fa-user" aria-hidden="true" />
          <span>پروفایل</span>
          </NavLink>
        */}
        {/*
          <NavLink className="vertical-menu-item" to="/dashboard/account">
            <i className="fa fa-user" aria-hidden="true" />
            <span>حساب کاربری</span>
          </NavLink>
        */}
      </div>;
  }
}

const mapStateToProps = state => state.routing.locationBeforeTransitions;
export default connect(mapStateToProps)(TeacherMenuItems);



// WEBPACK FOOTER //
// ./src/components/teacher/TeacherMenuItems.js